import React from "react";
import { useTranslation } from "react-i18next";
import { Pie } from "react-chartjs-2";
import { PIE_OPTIONS } from "../Requested/Model/Models";
import { colors } from '../../../../enums/colors';
/**
 * PieWhiteListFill
 *
 * Compares whitelist capacity vs actual registrations.
 *
 * @param {Array} summary - Registration summary
 * @param {number} countEventWhiteList - Whitelist capacity
 */

const PieWhiteListFill = ({
                              summary,
                              countEventWhiteList
                          }) => {
    const { t } = useTranslation();

    // Total registered attendees
    const registered =
        summary?.reduce((acc, item) => acc + (item?.total || 0), 0) || 0;

    // Whitelist capacity
    const whitelistTotal = countEventWhiteList || 0;

    const data = {
        labels: [
            t("total_invited"),
            t("checked_in")
        ],

        datasets: [
            {
                data: [
                    whitelistTotal,
                    registered
                ],

                backgroundColor: [
                    colors.secondary100, // whitelist
                    colors.accent50  // registered
                ]
            }
        ]
    };

    const total = whitelistTotal + registered;

    return (
        <>
            {total > 0 && (
                <div className="h-180px">
                    <Pie data={data} options={PIE_OPTIONS} />
                </div>
            )}
        </>
    );
};

export default PieWhiteListFill;
